import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

export const ScopeSelectedTaskAttemptSchema = z.object({
  type: z.literal(TaskType.SCOPE_SELECTED),
});
